"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var seesignage_utils_1 = require("@seesignage/seesignage-utils");
var Div_1 = __importDefault(require("../Div"));
var styles_1 = require("../../utils/styles");
var ProductData_1 = __importDefault(require("../ProductData"));
var products_1 = require("../../utils/products");
/*
 * Container component to handle multiple `ProductData` child components
 */
var Products = function (_a) {
    var mediaKeys = _a.mediaKeys, styles = _a.styles, items = _a.items, additionalProps = _a.additionalProps, id = _a.id, templateChildren = _a.templateChildren, currentComponentSchema = _a.currentComponentSchema;
    var children = currentComponentSchema.children;
    if (!children) {
        return react_1.default.createElement(react_1.Fragment, null);
    }
    var productDataIndexes = (0, products_1.getProductDataIndexes)(children);
    return (react_1.default.createElement(Div_1.default, { id: id, styles: (0, styles_1.removeNullValues)(styles) }, items.map(function (product, i) {
        var productDataIndex = productDataIndexes[i];
        // If styles does not exist for productData children, use empty StylesChild as failsafe.
        var productDataStylesChild = templateChildren[productDataIndex] || { children: [], styles: {} };
        var component = children[productDataIndex];
        // render only when productData schema component exist for productDataIndex.
        if (component && component.type === seesignage_utils_1.ComponentType.productData) {
            var productDataProps = {
                mediaKeys: mediaKeys,
                currentComponentSchema: component,
                templateChildren: productDataStylesChild.children,
                styles: productDataStylesChild.styles,
                items: [product],
                id: component.id,
                additionalProps: additionalProps
            };
            return react_1.default.createElement(ProductData_1.default, __assign({ key: component.id }, productDataProps));
        }
        return react_1.default.createElement(react_1.Fragment, { key: i });
    })));
};
exports.default = Products;
//# sourceMappingURL=Products.js.map